<template>
    <div class='member-welfare'>
        <market-title :iconClass="'iconhuiyuanfuli'"
            :title="'会员福利'"
            :des="'可展示会员相关活动与福利，可管理会员日折扣、会员充值等活动，有效进行会员营销'"/>
        <p class="title">会员日</p>
        <member-day-table/>
        <p class="title">充值送</p>
        <recharge-delivery-table/>
    </div>
</template>

<script lang='ts'>
import { createComponent, ref } from '@vue/composition-api'
import MarketTitle from '../../market/components/market_title.vue'
import RechargeDeliveryTable from '../../market/recharge_delivery/components/recharge_delivery_table.vue'
import MemberDayTable from '../../market/member_day/components/member_day_table.vue'

export default createComponent({
    components: {
        MarketTitle,
        RechargeDeliveryTable,
        MemberDayTable
    }
})
</script>

<style lang="scss" scoped>
.member-welfare {
    font-size: 14px;
    color: #333;

    .title {
        position: relative;
        margin-top: 12px;
        padding-left: 8px;
        line-height: 20px;
        font-weight: 600;

        &::before {
            content: '';
            position: absolute;
            left: 0;
            top: 0;
            width: 4px;
            height: 20px;
            border-radius: 2px;
            background-color: #009688;
        }
    }
}
</style>
